import React from 'react';
import MenuItem from '@bb-ui/react-library/dist/components/MenuItem/MenuItem';

export const mapToMenuItems = (
    options: { key: string; name: string | JSX.Element; invisible?: boolean }[],
) => {
    const invisibleProps = {
        disabled: true,
        style: { display: 'none' },
    };

    // TODO handle case where options is empty (pagination and table has zero rows)
    return options.map(option => (
        <MenuItem
            button
            key={option.key as string}
            value={option.key as string}
            {...(option.invisible ? invisibleProps : {})}
        >
            {option.name}
        </MenuItem>
    ));
};
